const Footer = () => (
  <footer className="footer position-absolute">
    <div className="row g-0 justify-content-between align-items-center h-100">
        <div className="col-12 col-sm-auto text-center">
            <p className="mb-0 mt-2 mt-sm-0 text-body">Designed & Developed by <a className="mx-1" href="tel:+919982158760">Mukan Singh</a><span
                    className="d-none d-sm-inline-block"></span><span className="d-none d-sm-inline-block mx-1">|</span><br
                    className="d-sm-none" />2025 &copy;<a className="mx-1" href="<?= $basePath ?>">FMS</a></p>
        </div>
        <div className="col-12 col-sm-auto text-center">
            <p className="mb-0 text-body-tertiary text-opacity-85">v1.1.0</p>
        </div>
    </div>
</footer>
);

export default Footer;
